import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";

type Props = {
  address: string;
  latitude: number;
  longitude: number;
};

const PropertyAddressViewer = ({ address, latitude, longitude }: Props) => {
  if (address?.length === 0 || !address) {
    return null;
  }
  return (
    <div>
      <Flex>
        <Typography fontWeight="bold">Address:</Typography>
        <Typography>{address}</Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">Latitude:</Typography>
        <Typography>{latitude}</Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">Longitude:</Typography>
        <Typography>{longitude}</Typography>
      </Flex>
    </div>
  );
};

export default PropertyAddressViewer;
